import React, { useEffect, useRef } from "react";
import DataTable, { TableColumn } from "@components/layouts/AppDataTable";
import * as XLSX from "xlsx";
import PageWrapper from "@components/layouts/PageWrapper";
import Search from "@components/layouts/Search";
import { useLocation, useNavigate } from "react-router-dom";
import usePagination from "@hooks/usePagination";
import useSearch from "@hooks/useSearch";
import { useDeleteProducutTagMutation } from "@states/product/product-tag.api";
import { useErrorHandling } from "@hooks/useErrorHandling";
import { castTypeArr } from "@utils/general/cast-type";
import { TFailResponse } from "@type-defs/general/TFailResponse";
import { DeletePopup } from "@helpers/popups/DeletePopup";
import TableSkeleton from "@components/layouts/TableSkeleton";
import { TDeleteSuccesResponse } from "@type-defs/general/TDeleteSuccessResponse";
import { Toast } from "@helpers/popups/Toast";
import useGetAllStockImports from "@hooks/warehouse-and-inventory/useGetAllStockImports";
import { STOCK_IMPORT } from "@utils/constants/warehouse-and-inventory/stock-import.constants";
import { stockImportColumns } from "@helpers/columns/warehouse-and-inventory/stock-import.columns";
import { stockBalanceColumns } from "@helpers/columns/warehouse-and-inventory/stock-balance.columns";
import NoRecord from "@components/layouts/NoRecord";
import useGetAllStockBalances from "@hooks/warehouse-and-inventory/useGetAllStockBalances";
import useGetAllWarehouses from "@hooks/warehouse-and-inventory/useGetAllWarehouses";
import { useDraggable } from "react-use-draggable-scroll";
import StockBalanceFilter from "@components/filters/StockBalanceFilter";
import rightArrow from "@assets/images/arrow-right.png";
import leftArrow from "@assets/images/back-arrow.png";
import { FaChevronLeft } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";
import { BsChevronBarLeft } from "react-icons/bs";
import { BsChevronBarRight } from "react-icons/bs";
import AuthComponent from "@components/auth/component";
import CustomButton from "@components/buttons/CustomButton";
import saveAs from "file-saver";
import { useLazyExportAllocationBalanceQuery } from "@states/warehouse-and-inventory/stock-balance.api";
const StockBalanceReportPage = () => {
    const { page, limit, handlePageChange, handlePerRowsChange } =
        usePagination();
    const { search, setSearch } = useSearch();
    const navigate = useNavigate();
    const location = useLocation();
    const tableContainerRef = useRef<any>();
    const { events } = useDraggable(tableContainerRef);

    const {
        stockBalanceError,
        stockBalanceRefetch,
        stockBalanceFetching,
        stockBalancePaginator,
        stockBalanceData,
    } = useGetAllStockBalances({
        page,
        limit,
        search: search,
    });

    const [triggerExport] = useLazyExportAllocationBalanceQuery();

    const stockBalanceTableData: any = stockBalanceData;
    const groupedWarehouses = stockBalanceTableData?.warehouses ?? [];
    const flattenedWarehouses =
        groupedWarehouses.flatMap((group: any) => group.warehouse_list ?? []) ??
        [];

    console.log("stockBalanceData", stockBalanceData);

    const { warehouseData, warehouseLoading } = useGetAllWarehouses({});

    const [deleteStockImport, { error: deleteError, isLoading }] =
        useDeleteProducutTagMutation();

    // a custom hook that will handle fetch/mutation errors
    useErrorHandling(
        ...castTypeArr<TFailResponse>([stockBalanceError, deleteError]),
    );

    useEffect(() => {
        if (location.state?.reload && stockBalanceRefetch) {
            stockBalanceRefetch();
        }
    }, [location.state?.reload, stockBalanceRefetch]);
    const editHandler = (warehouse_id: string | number) => {
        navigate(`${STOCK_IMPORT.BASE_PATH}${warehouse_id}/edit`);
    };

    //   const handleExportClick = () => {
    //     //@ts-ignore
    //     if (!stockBalanceData || !stockBalanceData.stock_balance) return;

    //     const exportData: any[] = [];
    //     //@ts-ignore
    //     stockBalanceData.stock_balance.forEach((row: any) => {
    //       const baseRow = {
    //         "Product Code": row.product_code_prefix
    //           ? `${row.product_code_prefix}${row.product_code}`
    //           : row.product_code,
    //         "Product Name": row.product_name,
    //         "Product Category": row.product_category_name,
    //         Unit: row.converted_unit_name,
    //       };

    //       // Add warehouse stock balance info dynamically
    //       //@ts-ignore
    //       stockBalanceData?.warehouses.forEach((mainWarehouse: any) => {
    //         mainWarehouse.warehouse_list.forEach((wh: any) => {
    //           const detail = row.details.find(
    //             (d: any) => d.warehouse_id === wh.warehouse_id
    //           );

    //           const whLabel = `${mainWarehouse.main_warehouse_name} - ${wh.warehouse_name}`;
    //           //@ts-ignore
    //           baseRow[`${whLabel} Balance Qty`] = detail?.convertedBalanceQty ?? 0;
    //           //@ts-ignore
    //           baseRow[`${whLabel} Pending Issue Qty`] =
    //             detail?.convertedGoodRequestQty ?? 0;
    //           //@ts-ignore
    //           baseRow[`${whLabel} Difference Qty`] = detail?.convertedDiffQty ?? 0;
    //         });
    //       });

    //       exportData.push(baseRow);
    //     });

    //     // Create worksheet and workbook
    //     const worksheet = XLSX.utils.json_to_sheet(exportData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Stock Balance");

    //     // Download Excel file
    //     XLSX.writeFile(workbook, "StockBalanceExport.xlsx");
    //   };
    const handleExportClick = async () => {
        try {
            const result = await triggerExport({}).unwrap();

            if (result) {
                saveAs(result, "allocation-balance-report.xlsx");
            }
        } catch (error) {
            console.error("Export failed:", error);
        }
    };
    const deleteHandler = async (id: number | string) => {
        try {
            const { isConfirmed } = await DeletePopup.fire();

            if (isConfirmed) {
                const res = await deleteStockImport(id);

                const successData = "data" in res ? res.data : null;
                const { success, message } =
                    successData as TDeleteSuccesResponse;

                if (success) {
                    Toast.fire({
                        icon: "success",
                        title: message,
                    });

                    stockBalanceRefetch();
                }
            }
        } catch (error) {
            console.log(error);
        }
    };
    //@ts-ignore
    const totalRecords = stockBalancePaginator?.total || 0;
    const totalPages = Math.ceil(totalRecords / limit);
    const onRowsChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newLimit = Number(event.target.value);
        //@ts-ignore
        handlePerRowsChange(newLimit); // Update the limit value
        handlePageChange(1); // Reset to the first page to avoid out-of-bound errors
    };

    return (
        <AuthComponent
            action="view"
            module="Report"
            subModule="Allocation Balance Report"
            page
        >
            <React.Fragment>
                <Search setSearch={setSearch} />
                <PageWrapper title="Allocation Balance Report">
                    {/* <StockBalanceFilter
            refetch={stockBalanceRefetch}
            filterRef={filterRef}
          /> */}

                    <div className="grid grid-cols-8 justify-evenly">
                        <div className="col-span-6"></div>
                        <div className=" flex items-center justify-end mt-2 col-span-2">
                            <CustomButton
                                title={
                                    <div className="flex  gap-3">
                                        <svg
                                            width="20"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M11.4126 17.2325V1H10.102C6.73567 1.60819 3.37848 2.17076 0 2.75462V18.1083C3.32374 18.6952 6.69006 19.2821 10.0351 19.8903H11.4035V17.2325H11.4126ZM6.46198 13.8632C6.04269 12.9666 5.67515 12.0467 5.36117 11.1081C5.05707 11.9991 4.63742 12.8384 4.2938 13.7111C3.81333 13.7111 3.33286 13.6837 2.8524 13.6655C3.41497 12.5616 3.9593 11.4486 4.54011 10.3539C4.04748 9.22268 3.50316 8.11579 2.99532 6.99368L4.44889 6.91158C4.77427 7.76912 5.1331 8.61754 5.40374 9.49637C5.70783 8.5628 6.12444 7.67181 6.49544 6.78386C6.99212 6.74939 7.48982 6.71898 7.98853 6.69263C7.40467 7.89278 6.81575 9.09598 6.22175 10.3022C6.82994 11.5186 7.43813 12.7502 8.04631 13.9787C7.51719 13.9361 6.99111 13.9027 6.46198 13.8632Z"
                                                fill="white"
                                            />
                                            <path
                                                d="M11.9658 3.10352V4.26819H14.2921V5.98632H11.9658V6.92901H14.2921V8.64714H11.9658V9.58983H14.2921V11.3049H11.9658V12.2476H14.2921V13.9505H11.9658V14.948H14.2921V16.6113H11.9658V17.776H20V3.10352H11.9658ZM18.2271 16.6235H14.8456V14.9601H18.2271V16.6235ZM18.2271 13.9627H14.8456V12.2446H18.2271V13.9627ZM18.2271 11.3019H14.8456V9.58679H18.2271V11.3019ZM18.2271 8.64106H14.8456V6.92597H18.2271V8.64106ZM18.2271 5.98024H14.8456V4.26819H18.2271V5.98024Z"
                                                fill="white"
                                            />
                                        </svg>
                                        Export Excel
                                    </div>
                                }
                                color="bg-[#1E6E42]"
                                handleClick={handleExportClick}
                                className=""
                            />
                        </div>
                    </div>

                    <div className="container w-full mt-10 col-span-full">
                        <div
                            ref={tableContainerRef}
                            {...events}
                            className="product-detail-table-wrapper w-[100%] mx-auto cursor-grab active:cursor-grabbing hide-scrollbar"
                        >
                            <table className="custom-table bg-white">
                                <thead className="h-12 py-3 text-xs font-light text-netural-600 bg-neutral-100 text-nowrap">
                                    <tr>
                                        <th
                                            className="px-4 py-2 text-xs font-light border-b border-gray-200 bg-neutral-100"
                                            rowSpan={3}
                                        >
                                            Product Code
                                        </th>
                                        <th
                                            className="px-4 py-2 text-left text-xs font-light border-b border-gray-200 bg-neutral-100"
                                            rowSpan={3}
                                        >
                                            Product Name
                                        </th>
                                        <th
                                            className="px-4 py-2 text-left text-xs font-light border-b border-gray-200 bg-neutral-100"
                                            rowSpan={3}
                                        >
                                            Product Category
                                        </th>
                                        <th
                                            className="px-4 py-2 text-left text-xs font-light border-b border-gray-200 bg-neutral-100"
                                            rowSpan={3}
                                        >
                                            Unit
                                        </th>
                                        {groupedWarehouses.map(
                                            (
                                                main_warehouse: any,
                                                index: number,
                                            ) => (
                                                <th
                                                    key={index}
                                                    className="px-4 py-2 text-center border border-gray-300"
                                                    colSpan={
                                                        (main_warehouse
                                                            ?.warehouse_list
                                                            ?.length ?? 0) * 3
                                                    }
                                                >
                                                    <div className="text-xs font-light py-2">
                                                        {
                                                            main_warehouse.main_warehouse_name
                                                        }
                                                    </div>
                                                </th>
                                            ),
                                        )}
                                    </tr>
                                    <tr>
                                        {groupedWarehouses.map(
                                            (main_warehouse: any) =>
                                                main_warehouse?.warehouse_list?.map(
                                                    (
                                                        warehouse: any,
                                                        warehouseIndex: number,
                                                    ) => (
                                                        <th
                                                            key={`${main_warehouse.main_warehouse_name}-${warehouseIndex}`}
                                                            className="px-4 py-2 text-center border border-gray-300"
                                                            colSpan={3}
                                                        >
                                                            {
                                                                warehouse.warehouse_name
                                                            }
                                                        </th>
                                                    ),
                                                ),
                                        )}
                                    </tr>
                                    <tr>
                                        {flattenedWarehouses.map(
                                            (warehouse: any, warehouseIndex: number) => (
                                                <React.Fragment
                                                    key={`${warehouse.warehouse_id}-${warehouseIndex}`}
                                                >
                                                    <th className="px-4 py-2 text-center border border-gray-300 text-xs font-light text-gray-500">
                                                        Balance Qty
                                                    </th>
                                                    <th className="px-4 py-2 text-center border border-gray-300 text-xs font-light text-gray-500">
                                                        Pending Issue Qty
                                                    </th>
                                                    <th className="px-4 py-2 text-center border border-gray-300 text-xs font-light text-gray-500">
                                                        Difference Qty
                                                    </th>
                                                </React.Fragment>
                                            ),
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {stockBalanceTableData?.stock_balance?.map(
                                        (row: any, rowIndex: any) => (
                                            <tr
                                                key={rowIndex}
                                                className="hover:bg-gray-100 border"
                                            >
                                                <td className="px-4 py-3 h-[3.1rem] border-b border-gray-200 text-nowrap text-primary-dark">
                                                    {row.product_code_prefix
                                                        ? `${row.product_code_prefix}${row.product_code}`
                                                        : `${row.product_code}`}
                                                </td>
                                                <td className="px-4 py-3 h-[3.1rem] border-b border-gray-200 text-nowrap">
                                                    {row.product_name}
                                                </td>
                                                <td className="px-4 py-3 h-[3.1rem] border-b border-gray-200 text-nowrap">
                                                    {row.product_category_name}
                                                </td>
                                                <td className="px-4 py-3 h-[3.1rem] border-b border-gray-200 text-nowrap">
                                                    <span>{row.converted_unit_name}</span>
                                                </td>
                                                {flattenedWarehouses.map(
                                                    (
                                                        warehouse: any,
                                                        warehouseIndex: number,
                                                    ) => {
                                                        const targetDetail =
                                                            row.details.find(
                                                                (
                                                                    detail: any,
                                                                ) =>
                                                                    detail.warehouse_id ===
                                                                    warehouse.warehouse_id,
                                                            );

                                                        return (
                                                            <React.Fragment
                                                                key={`${warehouse.warehouse_id}-${warehouseIndex}`}
                                                            >
                                                                <td className="px-4 py-3 h-[3.1rem] text-center border border-gray-300">
                                                                    <span>
                                                                        {targetDetail?.convertedBalanceQty ||
                                                                            0}
                                                                    </span>
                                                                    <span className="px-2">
                                                                        |
                                                                    </span>
                                                                    <span>
                                                                        {targetDetail?.baseBalanceQty ||
                                                                            0}
                                                                    </span>
                                                                </td>
                                                                <td className="px-4 py-3 h-[3.1rem] text-center border border-gray-300">
                                                                    <span>
                                                                        {targetDetail?.convertedGoodRequestQty ||
                                                                            0}
                                                                    </span>
                                                                    <span className="px-2">
                                                                        |
                                                                    </span>
                                                                    <span>
                                                                        {targetDetail?.baseGoodRequestQty ||
                                                                            0}
                                                                    </span>
                                                                </td>
                                                                <td className="px-4 py-3 h-[3.1rem] text-center border border-gray-300">
                                                                    <span>
                                                                        {targetDetail?.convertedDiffQty ||
                                                                            0}
                                                                    </span>
                                                                    <span className="px-2">
                                                                        |
                                                                    </span>
                                                                    <span>
                                                                        {targetDetail?.baseDiffQty ||
                                                                            0}
                                                                    </span>
                                                                </td>
                                                            </React.Fragment>
                                                        );
                                                    },
                                                )}
                                            </tr>
                                        ),
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {/* Pagination Controls */}
                        {/* Pagination Controls */}
                        <div className="flex items-center justify-end gap-5 mt-5">
                            {/* Rows per page */}
                            <div className="flex items-center gap-3">
                                <span>Rows per page</span>
                                <select
                                    onChange={onRowsChange}
                                    value={limit}
                                    className="border px-2"
                                >
                                    <option value={10}>10</option>
                                    <option value={15}>15</option>
                                    <option value={20}>20</option>
                                    <option value={25}>25</option>
                                    <option value={30}>30</option>
                                </select>
                            </div>
                            {/* Row Count Display */}
                            <div className="flex items-center gap-3">
                                <span>
                                    {page}-{(page - 1) * limit + 1} of{" "}
                                    {stockBalancePaginator?.totalItems}
                                </span>
                            </div>

                            {/* Pagination Buttons */}
                            <div className="flex items-center gap-3">
                                {/* First Page */}
                                <button
                                    disabled={page === 1}
                                    onClick={() => handlePageChange(1)}
                                    className={`p-2 ${page === 1 ? "text-gray-400" : ""}`}
                                >
                                    <BsChevronBarLeft />
                                </button>

                                {/* Previous Page */}
                                <button
                                    disabled={page === 1}
                                    onClick={() => handlePageChange(page - 1)}
                                    className={`p-2 ${page === 1 ? "text-gray-400" : ""}`}
                                >
                                    <FaChevronLeft />
                                </button>

                                {/* Next Page */}
                                <button
                                    //@ts-ignore
                                    disabled={
                                        page === totalPages ||
                                        //@ts-ignore
                                        stockBalanceData?.stock_balance
                                            ?.length === 0
                                    }
                                    onClick={() => handlePageChange(page + 1)}
                                    //@ts-ignore
                                    className={`p-2 ${
                                        page === totalPages ||
                                        //@ts-ignore
                                        stockBalanceData?.stock_balance
                                            ?.length === 0
                                            ? "text-gray-400"
                                            : ""
                                    }`}
                                >
                                    <FaChevronRight />
                                </button>

                                {/* Last Page */}
                                <button
                                    //@ts-ignore
                                    disabled={
                                        page === totalPages ||
                                        //@ts-ignore
                                        stockBalanceData?.stock_balance
                                            ?.length === 0
                                    }
                                    onClick={() => handlePageChange(totalPages)}
                                    //@ts-ignore
                                    className={`p-2 ${
                                        page === totalPages ||
                                        //@ts-ignore
                                        stockBalanceData?.stock_balance
                                            ?.length === 0
                                            ? "text-gray-400"
                                            : ""
                                    }`}
                                >
                                    <BsChevronBarRight />
                                </button>
                            </div>
                        </div>
                    </div>
                </PageWrapper>
            </React.Fragment>
        </AuthComponent>
    );
};

export default StockBalanceReportPage;

